import { render, staticRenderFns } from "./PresenceTable.vue?vue&type=template&id=a65bfca8&scoped=true"
import script from "./PresenceTable.vue?vue&type=script&lang=js"
export * from "./PresenceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65bfca8",
  null
  
)

export default component.exports